<template>
    <ValidationObserver ref="signup">
        <div class="form">
            <div class="row">
                <div class="col-lg-12">
                    <ValidationProvider
                        name="Name"
                        rules="required|latin|min:2|max:100"
                        v-slot="{ errors }"
                    >
                        <div class="form-group form-group-1">
                            <input
                                type="text"
                                class="form-control"
                                placeholder="First Name"
                                v-model="form.name"
                            >
                            <FormError :error="errors[0]" name="Name"></FormError>
                        </div>
                    </ValidationProvider>
                </div>

                <div class="col-lg-12">
                    <ValidationProvider
                        name="Last Name"
                        rules="required|latin|min:2|max:100"
                        v-slot="{ errors }"
                    >
                        <div class="form-group form-group-1">
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Last Name"
                                v-model="form.last_name"
                            >
                            <FormError :error="errors[0]" name="Last Name"></FormError>
                        </div>
                    </ValidationProvider>
                </div>

                <div class="col-lg-12">
                    <ValidationProvider
                        name="Email"
                        rules="required|email"
                        v-slot="{ errors }"
                    >
                        <div class="form-group form-group-1">
                            <input
                                type="email"
                                class="form-control"
                                placeholder="Email Address"
                                v-model="form.email"
                            >
                            <form-error :error="errors[0]" name="Email"></form-error>
                        </div>
                    </ValidationProvider>
                </div>

                <ValidationProvider class="col-lg-12" name="SSN" rules="required|customMin:11" v-slot="{ errors }">
                        <div class="form-group form-group-1">
                            <input
                                type="text"
                                class="form-control"
                                v-mask="'### ## ####'"
                                v-model="form.ssn"
                                placeholder="SSN"
                            >
                            <FormError :error="errors[0]" name="SSN"></FormError>
                        </div>
                </ValidationProvider>

                <div class="col-lg-12">
                    <p>Are you filling out your application at home or at the Orna Office?</p>
                    <ValidationProvider
                        name="Place"
                        rules="required"
                        v-slot="{ errors }"
                        class="d-flex align-items-center justify-content-start"
                        style="column-gap: 2rem"
                    >
                        <div class="form-group form-group-1">
                            <div class="form-check">
                                <input
                                    class="form-check-input-checkbox"
                                    type="radio" v-model="form.place"
                                    value="home"
                                >
                                <label class="form-check-label" for="home-office">
                                    Home
                                </label>
                            </div>
                            <FormError :error="errors[0]" name="Place"></FormError>
                        </div>
                        <div class="form-group form-group-1">
                            <div class="form-check">
                                <input
                                    class="form-check-input-checkbox"
                                    type="radio"
                                    v-model="form.place"
                                    value="office"
                                >
                                <label class="form-check-label" for="office-office">
                                    Office
                                </label>
                            </div>
                        </div>
                    </ValidationProvider>
                </div>

                <ValidationProvider
                    class="col-lg-12"
                    name="Agree"
                    rules="required"
                    v-slot="{ errors }"
                >
                    <div class="form-group form-group-1">
                        <div class="form-check">
                            <input
                                class="form-check-input-checkbox"
                                type="checkbox"
                                name="name312"
                                id="privacy"
                                value="1"
                                v-model="form.agree"
                            >
                            <label class="form-check-label" for="privacy">
                                I have read and agree to ORNA Security’s
                                <a
                                    href="javascript:void(0)"
                                    @click="showCustomModal('policy', 1)"
                                >
                                    Privacy Policy
                                </a>

                                <PrivacyPolicy
                                    :modal-id="getCustomModalId('policy', 1)"
                                />
                            </label>
                            <FormError :error="errors[0]" name="Agree" class="ml-3"></FormError>
                        </div>
                    </div>
                </ValidationProvider>

                <div class="col-12">
                    <button
                        @click="save"
                        class="btn btn--secondary w-100"
                    >Continue
                    </button>
                </div>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>

import ApplicationFormService from "../services/ApplicationFormService";
import AddNewFileModal from "../../../../../../resources/js/components/AddNewFileModal.vue";
import ModalHandler from "../../../../../../resources/js/mixins/ModalHandler";
import PrivacyPolicy from "../../../../../../resources/js/components/PrivacyPolicy.vue";

export default {
    name: 'ApplicantFormSignUp',
    components: {PrivacyPolicy, AddNewFileModal},
    mixins: [ModalHandler],
    data() {
        return {
            form: {
                name: null,
                last_name: null,
                email: null,
                place: null,
                agree: null,
                policy: null,
                ssn: null,
            }
        }
    },
    methods: {
        save() {
            (async () => {
                const valid = await this.$refs.signup.validate();

                if (!valid) {
                    this.$showValidationErrorMessage();
                    return;
                }
                try {
                    await  ApplicationFormService.register(this.form);
                    setTimeout(() => {
                        this.$showSuccessMessage("Successful registration!");
                    }, 1000)
                } catch (error) {
                    console.log(error.response)
                    if (error) {
                        const errors = error.response.data.errors;
                        let errorMessage = '';
                        let errorCount = 1;

                        for (const key in errors) {
                            if (errors.hasOwnProperty(key)) {
                                errors[key].forEach(err => {
                                    errorMessage += `${errorCount}. ${err}\n`;
                                    errorCount++;
                                });
                            }
                        }
                        this.$showErrorMessage(`${errorMessage}`);
                    }
                }
            })();
        },
    },
}


</script>

<style scoped>

.text-agree{
    font-weight: bold;
}

</style>
